var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHasRotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9494 6.42895H14.2242C14.6541 6.42895 15 6.07074 15 5.62549V1.34038C15 1.01565 14.8125 0.72105 14.5216 0.597184C14.2306 0.473317 13.8977 0.540272 13.6746 0.771266L12.3299 2.16393C9.49814 -0.731869 4.93696 -0.721826 2.12138 2.1974C-0.707128 5.12668 -0.707128 9.87377 2.12138 12.803C4.9499 15.7323 9.5337 15.7323 12.3622 12.803C12.7663 12.3846 12.7663 11.705 12.3622 11.2865C11.9581 10.8681 11.3019 10.8681 10.8979 11.2865C8.87749 13.3789 5.60288 13.3789 3.58251 11.2865C1.56215 9.19418 1.56215 5.80292 3.58251 3.71058C5.59318 1.62829 8.84193 1.61824 10.8655 3.6771L9.53693 5.05637C9.31388 5.28737 9.24923 5.63218 9.36884 5.93348C9.48844 6.23478 9.77291 6.42895 10.0865 6.42895H13.9494Z",
    fill: "#FF7E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasRotation);
export default __webpack_public_path__ + "static/media/has_rotation.acd73b67fa1efdeec170ef449d4746aa.svg";
export { ForwardRef as ReactComponent };